'use strict';

import { environment } from '@quartz-gov-legacy/environments/environment';

angular.module('searchModule')

.factory('searchService', ['$http', function ($http) {

    function returnData(response) {
        return response.data;
    }

    var service = {};

    // Configuration
    service.getConfiguration = function () {
        return $http
            .get(environment.apiUrl + '/Pilot/api/Search/Configuration')
            .then(function (response) { return response.data; });
    };

    // ActionPlans
    service.searchActionPlans = function (searchTerm, withoutFacets) {
        return service.searchItems('ActionPlan', searchTerm, withoutFacets);
    };

    // Controls
    service.searchControls = function (searchTerm, withoutFacets) {
        return service.searchItems('Control', searchTerm, withoutFacets);
    };

    // Observations
    service.searchObservations = function (searchTerm, withoutFacets) {
        return service.searchItems('Observation', searchTerm, withoutFacets);
    };

    // Recommendations
    service.searchRecommendations = function (searchTerm, withoutFacets) {
        return service.searchItems('Recommendation', searchTerm, withoutFacets);
    };

    // Risks
    service.searchRisks = function (searchTerm, withoutFacets) {
        return service.searchItems('Risk', searchTerm, withoutFacets);
    };

    // Risk Events
    service.searchRiskEvents = function (searchTerm, withoutFacets) {
        return service.searchItems('RiskEvent', searchTerm, withoutFacets);
    };

    // Plan Initiatives
    service.searchPlanInitiatives = function (searchTerm, withoutFacets) {
        return service.searchItems('PlanInitiative', searchTerm, withoutFacets);
    };

    // Generic search
    service.searchItems = function (itemType, searchTerm, withoutFacets) {
        var url = environment.apiUrl + '/Pilot/api/' + itemType + '/Search/';
        if (withoutFacets === true) {
            url += 'WithoutFacet/';
        }
        return $http
            .get(url + searchTerm, { ignoreError: true })
            .then(function (response) {
                _.forEach(response.data.Results, function (res) {
                    res._GOV = response.data._GOV;
                });
                return response.data;
            });
    };

    // Persons
    service.searchPersons = function (searchTerm) {
        return $http
            .get(environment.apiUrl + '/Pilot/api/Person/Search/' + searchTerm)
            .then(function (response) { return response.data; });
    };

    // Department Risks
    service.searchDepartmentRisks = function (searchTerm) {
        return $http
            .get(environment.apiUrl + '/Pilot/api/Risk/Department/Search/' + searchTerm)
            .then(function (response) { return response.data; });
    };

    // Procedure
    service.searchProcedure = function (searchTerm, withoutFacets) {
        var url = environment.apiUrl + '/Pilot/api/Procedure/Search/';
        if (withoutFacets) url += 'WithoutFacet/';
        return $http
            .get(url + searchTerm, { ignoreError: true })
            .then(returnData);
    };

    // Business Units
    service.searchBusinessUnits = function (searchTerm) {
        var url = environment.apiUrl + '/Pilot/api/BusinessUnit/Search/';
        return $http
            .get(url + searchTerm, { ignoreError: true })
            .then(returnData);
    };

    // IAM System
    service.searchIAMSystem = function (searchTerm, withoutFacets) {
        var url = environment.apiUrl + '/Pilot/api/IAMSystem/Search/V3/govProcedure/';
        var govSearchParam = { WithSignals: false};
        if (withoutFacets) govSearchParam.WithFacets = false;
        return $http
            .post(url + searchTerm, govSearchParam, { ignoreError: true })
            .then(returnData);
    };

    return service;
}]);
